export default __webpack_public_path__ + "static/banner-top-image-b-936024a0586ca1796fb20a7991c74700.png";